// import { FC } from 'react';
// import { Modal } from 'react-bootstrap';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }

// export const ApprovedListingDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {


//     const materialDocs = user.images?.filter(
//         (img: any) => img.docType === 'MATERIAL_DOC' || img.docType === 'SALE_DOC'
//     ) || [];



//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">Item Details</h1>
//                     </div>

//                     <div className="table-responsive">
//                         <table style={{
//                             width: '100%',
//                             borderCollapse: 'collapse',
//                             marginBottom: '20px',
//                             tableLayout: 'fixed' // This helps maintain consistent column widths
//                         }}>
//                             <thead>
//                                 <tr className="fw-bold bg-light">
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Grade</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Color</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Packaginng</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>

//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span>
//                                             {user.orderDetail[0]?.items[0]?.grade || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span>
//                                             {user.orderDetail[0]?.items[0]?.color || 'N/A'}
//                                         </span>
//                                     </td>

//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span>
//                                             {user.packagingType || 'N/A'}
//                                         </span>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>



//                     {materialDocs.length > 0 && (
//                         <div className="table-responsive mt-5">
//                             <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
//                                 <tbody>
//                                     {materialDocs.length > 0 && (
//                                         <div className="table-responsive mt-5">
//                                             <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
//                                                 <tbody>
//                                                     <tr>
//                                                         <td>
//                                                             <div className="d-flex flex-wrap gap-4 justify-content-start">
//                                                                 {materialDocs.map((doc: any, index: number) => (
//                                                                     <img
//                                                                         key={index}
//                                                                         src={doc.docUrl}
//                                                                         alt={`${doc.docType} Document`}
//                                                                         className="img-fluid cursor-pointer"
//                                                                         style={{
//                                                                             maxWidth: '200px',
//                                                                             maxHeight: '200px',
//                                                                             objectFit: 'cover',
//                                                                             border: '1px solid #ddd'
//                                                                         }}
//                                                                         onClick={() => window.open(doc.docUrl, '_blank')}
//                                                                     />
//                                                                 ))}
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}

//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={onClose}
//                         >
//                             Close
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };



















// import { FC, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import { useFormik } from 'formik';
// import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload';
// import axios from 'axios';
// import { successToast, errorToast } from '../../../../../../../_metronic/helpers/components/Toaster';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }

// export const ApprovedListingDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {
//     const [loading, setLoading] = useState(false);
//     const [quantity, setQuantity] = useState(user.orderDetail?.[0]?.items?.[0]?.quantity?.toString() || '');
//     const [price, setPrice] = useState(user.orderDetail?.[0]?.items?.[0]?.price?.toString() || '');
//     const [deliveryDate, setDeliveryDate] = useState(() => {
//         const timestamp = user.deliveryDate;
//         if (timestamp) {
//             const date = new Date(timestamp);
//             return date.toISOString().split('T')[0]; // Format as YYYY-MM-DD for date input
//         }
//         return '';
//     });

//     console.log("user is this", user)

//     const formik = useFormik({
//         initialValues: {
//             Image1: null,
//             Image2: null
//         },
//         onSubmit: (values) => {
//             console.log(values);
//         }
//     });

//     const materialDocs = user.images?.filter(
//         (img: any) => img.docType === 'MATERIAL_DOC' || img.docType === 'SALE_DOC'
//     ) || [];

//     const handleApprove = async () => {
//         try {
//             setLoading(true);

//             // Validate required inputs (images are optional)
//             if (!quantity || !price || !deliveryDate) {
//                 errorToast('Please fill all required fields (Quantity, Price, Delivery Date)');
//                 setLoading(false);
//                 return;
//             }

//             // Convert delivery date to timestamp
//             const deliveryDateTimestamp = new Date(deliveryDate).getTime();

//             // Update orderDetail with new quantity and price only
//             const updatedOrderDetail = user.orderDetail.map((order: any) => ({
//                 ...order,
//                 items: order.items.map((item: any) => ({
//                     ...item,
//                     quantity: parseFloat(quantity),
//                     price: parseFloat(price)
//                 }))
//             }));

//             // Prepare images array - only add uploaded images
//             const images: Array<{ docType: string; docUrl: string; docNumber: string }> = [];

//             if (formik.values.Image1) {
//                 images.push({
//                     docType: "VERIFIED_DOC",
//                     docUrl: formik.values.Image1,
//                     docNumber: ""
//                 });
//             }

//             if (formik.values.Image2) {
//                 images.push({
//                     docType: "VERIFIED_DOC",
//                     docUrl: formik.values.Image2,
//                     docNumber: ""
//                 });
//             }

//             // Prepare payload
//             const payload = {
//                 deliveryDate: deliveryDateTimestamp,
//                 packagingType: user.packagingType,
//                 orderDetail: updatedOrderDetail,
//                 images: images
//             };

//             console.log("Payload:", payload);

//             // Get auth data from localStorage
//             const authData = localStorage.getItem('kt-auth-react-v');
//             let authToken = '';
//             let pickupPointId = '';

//             if (authData) {
//                 try {
//                     const parsedAuth = JSON.parse(authData);
//                     authToken = parsedAuth?.data?.token || '';
//                     pickupPointId = parsedAuth?.data?.centreId || parsedAuth?.data?.franchiseId || '';
//                 } catch (e) {
//                     console.error('Error parsing auth data:', e);
//                 }
//             }

//             if (!authToken) {
//                 errorToast('Authentication token not found. Please login again.');
//                 setLoading(false);
//                 return;
//             }

//             // Make API call
//             const response = await axios.put(
//                 `https://pfc-backend-api.asmglobal.co.in/v1/api/saleOrders/${user.id}/verify`,
//                 payload,
//                 {
//                     headers: {
//                         'accept': 'application/json',
//                         'content-type': 'application/json',
//                         'pickuppointid': pickupPointId,
//                         'authorization': authToken,
//                         'app-id': '3',
//                         'client-id': '101212'
//                     }
//                 }
//             );

//             console.log("Response:", response.data);
//             successToast('Order approved successfully!');
//             onClose();

//         } catch (error: any) {
//             console.error("Error:", error);
//             errorToast(error?.response?.data?.message || 'Failed to approve order');
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">Item Details</h1>
//                     </div>

//                     {/* New Table with Input Fields */}
//                     <div className="table-responsive">
//                         <table style={{
//                             width: '100%',
//                             borderCollapse: 'collapse',
//                             marginBottom: '20px',
//                             tableLayout: 'fixed'
//                         }}>
//                             <thead>
//                                 <tr className="fw-bold bg-light">
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Quantity</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Price</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Delivery Date</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <input
//                                             type="number"
//                                             className="form-control"
//                                             value={quantity}
//                                             onChange={(e) => {
//                                                 const value = e.target.value;
//                                                 if (value === '' || parseFloat(value) >= 0) {
//                                                     setQuantity(value);
//                                                 }
//                                             }}
//                                             placeholder="Enter quantity"
//                                             min="0"
//                                             step="0.01"
//                                             required
//                                         />
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <input
//                                             type="number"
//                                             className="form-control"
//                                             value={price}
//                                             onChange={(e) => {
//                                                 const value = e.target.value;
//                                                 if (value === '' || parseFloat(value) >= 0) {
//                                                     setPrice(value);
//                                                 }
//                                             }}
//                                             placeholder="Enter price"
//                                             min="0"
//                                             step="0.01"
//                                             required
//                                         />
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <input
//                                             type="date"
//                                             className="form-control"
//                                             value={deliveryDate}
//                                             onChange={(e) => setDeliveryDate(e.target.value)}
//                                             required
//                                         />
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                     <div className="table-responsive">
//                         <table style={{
//                             width: '100%',
//                             borderCollapse: 'collapse',
//                             marginBottom: '20px',
//                             tableLayout: 'fixed'
//                         }}>
//                             <thead>
//                                 <tr className="fw-bold bg-light">
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Grade</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Color</th>
//                                     <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
//                                     >Packaging</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span>
//                                             {user.orderDetail?.[0]?.items?.[0]?.grade || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span>
//                                             {user.orderDetail?.[0]?.items?.[0]?.color || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
//                                         <span>
//                                             {user.packagingType || 'N/A'}
//                                         </span>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* Images and Upload side by side */}
//                     {/* <div className="row mt-5">
//                         {materialDocs.length > 0 && (
//                             <div className="col-md-6">
//                                 <h5 className="mb-3">Material Documents</h5>
//                                 <div className="d-flex flex-wrap gap-4 justify-content-start">
//                                     {materialDocs.map((doc: any, index: number) => (
//                                         <img
//                                             key={index}
//                                             src={doc.docUrl}
//                                             alt={`${doc.docType} Document`}
//                                             className="img-fluid cursor-pointer"
//                                             style={{
//                                                 maxWidth: '200px',
//                                                 maxHeight: '200px',
//                                                 objectFit: 'cover',
//                                                 border: '1px solid #ddd'
//                                             }}
//                                             onClick={() => window.open(doc.docUrl, '_blank')}
//                                         />
//                                     ))}
//                                 </div>
//                             </div>
//                         )}

//                         <div className={materialDocs.length > 0 ? "col-md-6" : "col-md-12"}>
//                             <h5 className="mb-3">Upload Images (Optional)</h5>
//                             <div className="mb-3">
//                                 <UploadImage name='Image1' formik={formik} label='Upload Image 1' />
//                             </div>
//                             <div className="mb-3">
//                                 <UploadImage name='Image2' formik={formik} label='Upload Image 2' />
//                             </div>
//                         </div>
//                     </div> */}

//                     {/* Images and Upload side by side */}
//                     <div className="row mt-5">
//                         {materialDocs.length > 0 && (
//                             <div className="col-md-12 mb-4">
//                                 <h5 className="mb-3">Material Documents</h5>
//                                 <div className="d-flex flex-wrap gap-4 justify-content-start">
//                                     {materialDocs.map((doc: any, index: number) => (
//                                         <img
//                                             key={index}
//                                             src={doc.docUrl}
//                                             alt={`${doc.docType} Document`}
//                                             className="img-fluid cursor-pointer"
//                                             style={{
//                                                 maxWidth: '200px',
//                                                 maxHeight: '200px',
//                                                 objectFit: 'cover',
//                                                 border: '1px solid #ddd'
//                                             }}
//                                             onClick={() => window.open(doc.docUrl, '_blank')}
//                                         />
//                                     ))}
//                                 </div>
//                             </div>
//                         )}

//                         <div className="col-md-12">
//                             <h5 className="mb-3">Upload Images (Optional)</h5>
//                             <div className="row">
//                                 <div className="col-md-6 mb-3">
//                                     <UploadImage name='Image1' formik={formik} label='Upload Image 1' />
//                                 </div>
//                                 <div className="col-md-6 mb-3">
//                                     <UploadImage name='Image2' formik={formik} label='Upload Image 2' />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={onClose}
//                             disabled={loading}
//                         >
//                             Close
//                         </button>
//                         <button
//                             type="button"
//                             className="btn btn-primary"
//                             onClick={handleApprove}
//                             disabled={loading}
//                         >
//                             {loading ? 'Approving...' : 'Approve'}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };















import { FC, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload';
import axios from 'axios';
import { successToast, errorToast } from '../../../../../../../_metronic/helpers/components/Toaster';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

interface ColorType {
    colorName: string;
    color: string;
}

interface Grade {
    id?: string;
    gradeName?: string;
    [key: string]: any;
}

export const ApprovedListingDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const [quantity, setQuantity] = useState(user.orderDetail?.[0]?.items?.[0]?.quantity?.toString() || '');
    const [price, setPrice] = useState(user.orderDetail?.[0]?.items?.[0]?.price?.toString() || '');
    const [deliveryDate, setDeliveryDate] = useState(() => {
        const timestamp = user.deliveryDate;
        if (timestamp) {
            const date = new Date(timestamp);
            return date.toISOString().split('T')[0];
        }
        return '';
    });
    const [loading, setLoading] = useState(false);

    // New states for dropdowns
    const [grades, setGrades] = useState<Grade[]>([]);
    const [colors, setColors] = useState<ColorType[]>([]);
    const [packaging, setPackaging] = useState<string[]>([]);
    const [selectedGrade, setSelectedGrade] = useState(user.orderDetail?.[0]?.items?.[0]?.grade || '');
    const [selectedColor, setSelectedColor] = useState(user.orderDetail?.[0]?.items?.[0]?.color || '');
    const [selectedPackaging, setSelectedPackaging] = useState(user.packagingType || '');

    console.log("currently hereeee", user)

    const formik = useFormik({
        initialValues: {
            Image1: null,
            Image2: null
        },
        onSubmit: (values) => {
            console.log(values);
        }
    });

    const materialDocs = user.images?.filter(
        (img: any) => img.docType === 'MATERIAL_DOC' || img.docType === 'SALE_DOC'
    ) || [];

    // Fetch Grade, Color, and Packaging data
    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                setLoading(true);

                // Get itemId from user data
                const itemId = user.orderDetail?.[0]?.items?.[0]?.itemId;

                if (itemId) {
                    // Fetch Grade based on itemId
                    const gradeRes = await fetch(
                        `https://pfc-backend-api.asmglobal.co.in/v1/api/grade/item/${itemId}`
                    );
                    const gradeData = await gradeRes.json();

                    if (gradeData && Array.isArray(gradeData.data)) {
                        setGrades(gradeData.data);
                    } else if (Array.isArray(gradeData)) {
                        setGrades(gradeData);
                    } else {
                        setGrades([]);
                    }
                }

                // Fetch Color
                const colorRes = await fetch(
                    'https://pfc-backend-api.asmglobal.co.in/v1/api/color'
                );
                const colorData = await colorRes.json();
                setColors(colorData.data || []);

                // Fetch Packaging
                const packRes = await fetch(
                    'https://pfc-backend-api.asmglobal.co.in/v1/api/packaging'
                );
                const packData = await packRes.json();
                setPackaging(packData.data || []);

            } catch (error) {
                console.error('Error fetching dropdown data:', error);
                errorToast('Error loading dropdown data');
            } finally {
                setLoading(false);
            }
        };

        if (user && show) {
            fetchDropdownData();
        }
    }, [user, show]);

    const handleApprove = async () => {
        try {
            setLoading(true);

            // Validate required inputs
            if (!quantity || !price || !deliveryDate || !selectedGrade || !selectedColor || !selectedPackaging) {
                errorToast('Please fill all required fields');
                setLoading(false);
                return;
            }

            // Convert delivery date to timestamp
            const deliveryDateTimestamp = new Date(deliveryDate).getTime();

            // Update orderDetail with new values
            const updatedOrderDetail = user.orderDetail.map((order: any) => ({
                ...order,
                items: order.items.map((item: any) => ({
                    ...item,
                    quantity: parseFloat(quantity),
                    price: parseFloat(price),
                    grade: selectedGrade,
                    color: selectedColor
                }))
            }));

            // Prepare images array
            const images: Array<{ docType: string; docUrl: string; docNumber: string }> = [];

            if (formik.values.Image1) {
                images.push({
                    docType: "VERIFIED_DOC",
                    docUrl: formik.values.Image1,
                    docNumber: ""
                });
            }

            if (formik.values.Image2) {
                images.push({
                    docType: "VERIFIED_DOC",
                    docUrl: formik.values.Image2,
                    docNumber: ""
                });
            }

            // Prepare payload
            const payload = {
                deliveryDate: deliveryDateTimestamp,
                packagingType: selectedPackaging,
                orderDetail: updatedOrderDetail,
                images: images
            };

            console.log("Payload:", payload);

            // Get auth data from localStorage
            const authData = localStorage.getItem('kt-auth-react-v');
            let authToken = '';
            let pickupPointId = '';

            if (authData) {
                try {
                    const parsedAuth = JSON.parse(authData);
                    authToken = parsedAuth?.data?.token || '';
                    pickupPointId = parsedAuth?.data?.centreId || parsedAuth?.data?.franchiseId || '';
                } catch (e) {
                    console.error('Error parsing auth data:', e);
                }
            }

            if (!authToken) {
                errorToast('Authentication token not found. Please login again.');
                setLoading(false);
                return;
            }

            // Make API call
            const response = await axios.put(
                `https://pfc-backend-api.asmglobal.co.in/v1/api/saleOrders/${user.id}/verify`,
                payload,
                {
                    headers: {
                        'accept': 'application/json',
                        'content-type': 'application/json',
                        'pickuppointid': pickupPointId,
                        'authorization': authToken,
                        'app-id': '3',
                        'client-id': '101212'
                    }
                }
            );

            console.log("Response:", response.data);
            successToast('Order approved successfully!');
            onClose();

        } catch (error: any) {
            console.error("Error:", error);
            errorToast(error?.response?.data?.message || 'Failed to approve order');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>

                    {/* Quantity, Price, Delivery Date Table */}
                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>
                                        Quantity
                                    </th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>
                                        Price
                                    </th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>
                                        Delivery Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={quantity}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === '' || parseFloat(value) >= 0) {
                                                    setQuantity(value);
                                                }
                                            }}
                                            placeholder="Enter quantity"
                                            min="0"
                                            step="0.01"
                                            required
                                        />
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={price}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === '' || parseFloat(value) >= 0) {
                                                    setPrice(value);
                                                }
                                            }}
                                            placeholder="Enter price"
                                            min="0"
                                            step="0.01"
                                            required
                                        />
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={deliveryDate}
                                            onChange={(e) => setDeliveryDate(e.target.value)}
                                            required
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Grade, Color, Packaging Table */}
                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>
                                        Grade
                                    </th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>
                                        Color
                                    </th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>
                                        Packaging
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <select
                                            className="form-control"
                                            value={selectedGrade}
                                            onChange={(e) => setSelectedGrade(e.target.value)}
                                            disabled={loading}
                                            required
                                        >
                                            <option value="">Select Grade</option>
                                            {grades.map((grade, index) => (
                                                <option key={grade.id || `grade-${index}`} value={grade.gradeName || ''}>
                                                    {grade.gradeName || `Grade ${index + 1}`}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    {/* <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <select
                                            className="form-control"
                                            value={selectedColor}
                                            onChange={(e) => setSelectedColor(e.target.value)}
                                            disabled={loading}
                                            required
                                        >
                                            <option value="">Select Color</option>
                                            {colors.map((color) => (
                                                <option key={color.colorName} value={color.colorName}>
                                                    {color.colorName}
                                                </option>
                                            ))}
                                        </select>
                                    </td> */}
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <select
                                            className="form-control"
                                            value={selectedColor}
                                            onChange={(e) => setSelectedColor(e.target.value)}
                                            disabled={loading}
                                            required
                                            style={{
                                                backgroundImage: selectedColor
                                                    ? `url(${colors.find((c) => c.colorName === selectedColor)?.color})`
                                                    : 'none',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'right 10px center',
                                                backgroundSize: '25px 25px',
                                                paddingRight: '45px'
                                            }}
                                        >
                                            <option value="">Select Color</option>
                                            {colors.map((color) => (
                                                <option
                                                    key={color.colorName}
                                                    value={color.colorName}
                                                    style={{
                                                        backgroundImage: `url(${color.color})`,
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundPosition: 'right 10px center',
                                                        backgroundSize: '20px 20px',
                                                        paddingRight: '40px'
                                                    }}
                                                >
                                                    {color.colorName}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <select
                                            className="form-control"
                                            value={selectedPackaging}
                                            onChange={(e) => setSelectedPackaging(e.target.value)}
                                            disabled={loading}
                                            required
                                        >
                                            <option value="">Select Packaging</option>
                                            {packaging.map((pack) => (
                                                <option key={pack} value={pack}>
                                                    {pack}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>



                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        padding: '10px',
                                        textAlign: 'left',
                                        border: '1px solid #ddd',
                                        backgroundColor: '#bfd7ed',
                                        fontWeight: 600
                                    }}>
                                        Remarks
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span>{user.remarks || 'No remarks'}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Images and Upload */}
                    <div className="row mt-5">
                        {materialDocs.length > 0 && (
                            <div className="col-md-12 mb-4">
                                <h5 className="mb-3"></h5>
                                <p style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>Material Documents</p>
                                <div className="d-flex flex-wrap gap-4 justify-content-start">
                                    {materialDocs.map((doc: any, index: number) => (
                                        <img
                                            key={index}
                                            src={doc.docUrl}
                                            alt={`${doc.docType} Document`}
                                            className="img-fluid cursor-pointer"
                                            style={{
                                                maxWidth: '200px',
                                                maxHeight: '200px',
                                                objectFit: 'cover',
                                                border: '1px solid #ddd'
                                            }}
                                            onClick={() => window.open(doc.docUrl, '_blank')}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}



                        <div className="col-md-12">
                            {/* <h5 className="mb-3">Upload Images (Optional)</h5> */}
                            <p style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>Upload Images (Optional)</p>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <UploadImage name='Image1' formik={formik} label='Upload Image 1' />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <UploadImage name='Image2' formik={formik} label='Upload Image 2' />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleApprove}
                            disabled={loading}
                        >
                            {loading ? 'Approving...' : 'Approve'}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};